module.exports = __webpack_public_path__ + "images/dingtalk/ad20160530/3-73cbcc3287a198b1a59b06e7b97a73d3.png";